import { routerReducer as router } from 'react-router-redux'
import { combineReducers } from 'redux'
import authReducer from './auth-reducer'

import projectReducer from './project-reducer';
import organizationReducer from './organization-reducer';
import resourceReducer from './resource-reducer';
import glossaryReducer from './glossary-reducer';
import readingListReducer from './reading-list-reducer';
import usersReducer from './users-reducer';
import localStorageReducer from './local-storage-reducer'
import dictionariesReducer from './dictionaries-reducer'

export default combineReducers({
    projects: projectReducer,
    organizations: organizationReducer,
    resources: resourceReducer,
    glossary: glossaryReducer,
    readingList: readingListReducer,
    router,
    authReducer,
    users: usersReducer,
    localStorage: localStorageReducer,
    dictionaries: dictionariesReducer
});


// WEBPACK FOOTER //
// ./src/reducers/index.js